import { defineStore } from 'pinia'

export const useUserStore = defineStore('user', {
  state: () => ({
    origins: '', // 来源页面
    action: 0, // 来源接口   1:展位预订  2:门票预订  3:展商名录  4:开展提醒
    industryId: 0, // 展会行业
    bdUrl: '',
    userInfo: null as any,
    token: '',
    isLoggedIn: false,
  }),

  getters: {
    getToken: (state) => state.token,
    getUserInfo: (state) => state.userInfo,
    getOrigins: (state) => state.origins,
  },

  actions: {
    setToken(token: string) {
      this.token = token
      this.isLoggedIn = !!token
      
      const tokenCookie = useCookie('access_token', {
        maxAge: 60 * 60 * 24 * 7, // 7 days
        sameSite: 'lax',
      })
      tokenCookie.value = token
    },
    setAction(data: any) {
      this.action = data
    },
    setIndustryId(data: any) {
      this.industryId = data
    },
    setBDurl(data: any) {
      this.bdUrl = data
    },

    setUserInfo(userInfo: any) {
      this.userInfo = userInfo
    },

    setOrigins(origins: string) {
      this.origins = origins
    },

    logout() {
      this.token = ''
      this.userInfo = null
      this.isLoggedIn = false
      
      const tokenCookie = useCookie('access_token')
      tokenCookie.value = null
    },

    async getUserProfile() {
      try {
        const result = await useHttp.post('/api/userApi/profile')
        if (result?.code === '1') {
          this.setUserInfo(result.data)
          return result.data
        }
      } catch (error) {
        console.error('获取用户信息失败:', error)
        this.logout()
      }
    },

    // 初始化用户状态
    async initUser() {
      const tokenCookie = useCookie('access_token')
      if (tokenCookie.value) {
        this.setToken(tokenCookie.value)
        await this.getUserProfile()
      }
    },
  },
})